/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Restart Cloud Shell",
  size: 20
}

const SvgRestartCloudShell = ({ size, ...props }: Props) => (
  <Svg
    viewBox="0 0 20 20"
    height={size}
    width={size}
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <g fill="none">
      <path d="M15.6 5c1.3 1.3 2.1 3 2.1 5 0 3.9-3.2 7-7.1 7-3.9 0-7.1-3.2-7.1-7 0-.8.2-1.7.4-2.4" />
      <path d="M1 10.2l2.9-2.9 3 3M10.6 10V2.5" />
    </g>
  </Svg>
)

SvgRestartCloudShell.defaultProps = defaultProps
export default SvgRestartCloudShell
